import Vue from 'vue';
import App from './App.vue';

Vue.config.productionTip = false;

const getUrlParams = () => {
  const params = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    params[key] = value;
  });
  return params;
};

new Vue({
  render: h => h(App, { props: getUrlParams() }),
}).$mount('#app');
